/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { DatePicker, Radio, Button, Spin } from 'antd'
import moment from 'moment'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'
import Report from './report'
const { RangePicker } = DatePicker

export default class extends React.Component {
  state = {
    size: '0',
    visible: false,
    loading: false,
    radioValue: 2,
  }

  onChange = (value, dateString) => {
    if (value.length > 0) {
      this.props.getPeriod({
        start_time: dateString[0],
        end_time: dateString[1],
      })
    } else {
      this.props.getPeriod({ start_time: null, end_time: null }) //清除
    }
  }

  handleSizeChange = (e) => {
    this.setState({ size: e.target.value })
    this.props.fetchTimePeriod(e.target.value) //时间范围
  }

  handleButton = () => {
    const data = {
      start_time:
        moment(this.props.period.start_time).format('YYYY-MM-DD HH:mm:ss') ||
        '',
      end_time:
        moment(this.props.period.end_time).format('YYYY-MM-DD HH:mm:ss') || '',
      statisticType: this.state.radioValue,
    }
    this.setState({ loading: true })
    this.props.fetchSearchStandby(data).then((res) => {
      this.setState({ loading: false })
    })
  }

  onTypeEvent = (type) => {
    this.setState({
      radioValue: type,
    })
  }

  render() {
    const { size } = this.state
    const { standbyList, period } = this.props

    return (
      <div>
        <Radio.Group
          value={size}
          onChange={this.handleSizeChange}
          style={{ display: 'block', marginBottom: '1rem' }}
        >
          <Radio.Button value="1">昨日</Radio.Button>
          <Radio.Button value="2">今日</Radio.Button>
          <Radio.Button value="3">上月</Radio.Button>
          <Radio.Button value="4">本月</Radio.Button>
          <Radio.Button value="5">去年</Radio.Button>
          <Radio.Button value="6">今年</Radio.Button>
        </Radio.Group>
        <RangePicker
          showTime={false}
          format="YYYY-MM-DD"
          placeholder={['开始时间', '结束时间']}
          value={
            period.start_time
              ? [
                moment(`${period.start_time}`, 'YYYY-MM-DD'),
                moment(`${period.end_time}`, 'YYYY-MM-DD'),
              ]
              : null
          }
          onChange={this.onChange}
        />
        <NineAndZeroRadio typeEvent={this.onTypeEvent} />
        <div style={{ marginTop: '1rem' }}>
          <Button type="primary" onClick={() => this.handleButton('2')}>
            {/*<Link to={'/home/ClubBusiness/Report/'+ record_type}>显示</Link>*/}
            显示
          </Button>
        </div>

        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Report period={period} list={standbyList} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStandby/component/standby.js